<template>
  <div class="order_content" v-show="!isHidePage" ref="fillGuestForm">
    <div class="warp1200">
      <div class="msg_con">
        
        <!--抖音核销-->
        <template v-if="getTikTokCouponStatus(booking.tikTokCouponStatus) && booking.status != 'CANCELLED'">
          <template v-if="booking.isRow == false">
            <div v-if="booking.tikTokCouponStatus === 1" class="tik-tok-header">您的申请已收到，会为您尽快完成审核。（预计48小时内完成审核）请您尽快在抖音完成预约以便客服专员完成审核，谢谢。</div>
            <div v-else-if="booking.tikTokCouponStatus === 3" class="tik-tok-header">抱歉，您未在规定时间内提交审核，请重新发起申请。</div>
          </template>
        </template>
        <template v-else>
          <span
              class="count-down"
              v-if="booking.localStatus == 15 || booking.status == 'CANCELLED'"
          >
            <img
                src="https://resource.rcclchina.com.cn/tui2/order/icon-order-msg.png"
            />
            很遗憾，您未在规定时间内完成支付，订单已取消！请<router-link
              to="/Rccl.Cruise/CruiseSearch/Search"
          >重新下单</router-link
          >，这个旅程超棒，赶快去锁定它吧！
          </span>
          <span class="count-down" v-else-if="canPay && isNotPayInFull">
            <img
                src="https://resource.rcclchina.com.cn/tui2/order/icon-order-msg.png"
            />
            您已支付订金，务必在<span>{{ retainTime }}</span
          >前支付尾款～！ 这个旅程超棒，赶快下单不让自己遗憾！
          </span>
          <span
              class="count-down"
              v-else-if="
              canPay &&
              booking.localStatus != 15 &&
              booking.localStatus != 10 &&
              booking.status != 'CANCELLED'
            "
          >
            <img
                src="https://resource.rcclchina.com.cn/tui2/order/icon-order-msg.png"
            />
            您已下单成功，由于客房紧张，该订单将保留到
            <span class="red">{{ retainTime }}</span
            >，请尽快完成支付！
          </span>
        </template>
      </div>
      <div class="line_con">
        <div class="line_info_con">
          <div class="ship_way">
            {{ cruise.cruiseRoute }}
          </div>
          <div class="ship_time">
            <span>{{ cruise.sailDays }}天{{ cruise.sailDays - 1 }}晚</span>
            <span>{{ cruise.shipName }}</span>
          </div>
          <div class="ship_time">
            <span
            >{{ bookingDetail.sailDateBegin }} -
              {{ bookingDetail.sailDateEnd }}</span
            >
          </div>
          <CruisePortsPopup :is-sale="bookingDetail?.isSale"
                            :ship-code="cruise.shipCode"
                            :sail-date="cruise.sailDate"></CruisePortsPopup>
        </div>
        <div class="user_info">
          <div class="ship_way">联系人信息</div>
          <div class="privacy-layout">
            <privacy-button @privacy-switch="reload" type="text-mini"></privacy-button>
          </div>
          <div class="ship_time guestContact">
            <span class="line_label"
            >姓<span style="margin-left: 16px">名：</span></span
            >
            <span class="contactName">{{ contactName }}</span>
            <span
                class="more_day cursor-pointer"
                id="updateBookingContact"
                @click="isShowChangeContactPopup = true"
            >
              <i class="order_ico_25 edit_ico"></i> 编辑
            </span>
          </div>
          <div class="ship_time guestContact">
            <span class="line_label">手机号：</span>
            <span class="contactTelephone">{{ contact.telephone }}</span>
          </div>
          <div class="ship_time guestContact">
            <span class="line_label" style="letter-spacing: 2px">Email：</span>
            <span class="contactEmail">{{ contact.email }}</span>
          </div>
        </div>
      </div>

      <div class="order_con">
        <div class="order_info_con">
          <span style="font-size: 16px">船票预订号：</span>
          <span class="info_text fw-400">{{ booking.bookingId }}</span>
          <template v-if="getTikTokCouponStatus(booking.tikTokCouponStatus) && booking.status != 'CANCELLED'">
            <div v-if="booking.tikTokCouponStatus === 1" class="or_stu or_stu_unpay">待审核</div>
            <div v-else-if="booking.tikTokCouponStatus === 3" class="or_stu or_stu_paid">已拒绝</div><span v-if="booking.tikTokRejectReason" class="reject_text">（{{booking.tikTokRejectReason}}）</span>
          </template>
          <template v-else>
            <div
                class="or_stu or_stu_paid"
                v-if="booking.localStatus == 15 || booking.status == 'CANCELLED'"
            >
              <span class="ft_12 fw-400">已取消</span>
            </div>
            <div class="or_stu or_stu_unpay" v-else-if="canPay && isNotPayInFull">
              <span class="ft_12 fw-400">未全付款</span>
            </div>
            <div
                class="or_stu or_stu_unpay"
                v-else-if="
              canPay &&
              booking.localStatus != 15 &&
              booking.localStatus != 10 &&
              booking.status != 'CANCELLED'
            "
            >
              <span class="ft_12 fw-400">未付款</span>
            </div>
            <!-- <div class="or_stu or_stu_paid" v-else><span class="ft_12 fw-400">已付款</span></div> -->
          </template>
        </div>
        <div class="room_con">
          <div class="head_con">
            <div class="fw-400">
              {{
                stateroomName +
                "_" +
                stateroomCategoryCode +
                "(" +
                stateroomGuestNumber +
                ")"
              }}
              <img
                  v-if="booking.connectId && booking.connectId.length > 0"
                  class="c_infoImg"
                  @click="isShowConnectRoomPopup = true"
                  src="https://resource.rcclchina.com.cn/cruiseDetail/pc/custom_info.png"
                  alt=""
              />
              <a
                  v-if="
                  booking.encConnectBookingId &&
                  booking.encConnectBookingId.length > 0
                "
                  class="connect_room_link"
                  :href="
                  '/Rccl.Booking/Booking/BookingDetail?bookingId=' +
                  booking.encConnectBookingId
                "
              >
                <img
                    src="https://resource.rcclchina.com.cn/connectRoom/connect_d_order.png"
                />
              </a>
              <img
                  v-if="bookingDetail.groupType == 'QIAOHU'"
                  @click="showQiaohuPopup"
                  class="qiaohu_tag"
                  src="https://resource.rcclchina.com.cn/QIAOHU/qiaohu.png"
              />
              <img
                  v-else-if="bookingDetail.groupType == 'STARRYSKY'"
                  @click="showStarrySkyPopup"
                  class="qiaohu_tag"
                  src="https://resource.rcclchina.com.cn/STARRYSKY/PC/PC_icon.png"
              />
              <img
                  v-else-if="bookingDetail.groupType == 'PCPGIFT'"
                  @click="showCustomThemePopup(bookingDetail.stateroomCategory?.personalizedStateroomInfo)"
                  class="PCPGIFT_THEME_CSS qiaohu_tag"
                  :src="bookingDetail.stateroomCategory?.personalizedStateroomInfo?.roomIconImage"
              />
              <img
                  v-else-if="bookingDetail.groupType == 'CUSTOM'"
                  @click="showCustomThemePopup(bookingDetail.stateroomCategory?.personalizedStateroomInfo)"
                  class="CUSTOM_THEME_CSS qiaohu_tag"
                  :src="bookingDetail.stateroomCategory?.personalizedStateroomInfo?.roomIconImage"
              />
            </div>
            <div
                class="head_tag stateroomDetailTag fw-400"
                @click="showStateroomDetailPopup"
                style="margin-left: 5px"
            >
              舱房详情
            </div>
            <div
                v-if="bookingDetail.isFortyEightHoursNrpCruise"
                class="head_tag fw-400"
                style="margin-left: 5px"
            >
              <NrpTag
                  :isNrp="booking.isnrp"
                  :isFortyEightHoursNrpCruise="
                  bookingDetail.isFortyEightHoursNrpCruise
                "
                  :direction="'right'"
                  :customClasses="['bookingDetail']"
                  :targetContainer="'app'"
                  :showRow="booking.isRow"
              />
            </div>

            <NrpTag
                v-else
                class="nrpTooltip"
                :isNrp="booking.isnrp"
                :isFortyEightHoursNrpCruise="
                bookingDetail.isFortyEightHoursNrpCruise
              "
                :direction="'right'"
                :targetContainer="'app'"
                :showRow="booking.isRow"
            />
            <div class="bidding-status" @click="showWxQrCode()" :style="{ background:upgradeCabinItem.biddingStatus===10||
                 upgradeCabinItem.biddingStatus===40||upgradeCabinItem.biddingStatus===50?'#5cb139':'' }"
                 v-if="upgradeCabinItem && upgradeCabinItem.displayBiddingEntrance">
              <img src="https://resource.rcclchina.com.cn/wechatMiniProgram/bidding/bidding-icon-white3.svg" alt="">
              <div v-if="upgradeCabinItem.canBidding">
                <span v-if="upgradeCabinItem.biddingStatus==20">未竞价成功</span>
                <span v-else>竞价升房</span>
              </div>
              <div v-if="!upgradeCabinItem.canBidding">
                <span>{{getBiddingStatusText(upgradeCabinItem.biddingStatus)}}</span>
              </div>
            </div>
          </div>
          <div class="room_det">
            <span>
              人数：{{ bookingGuests.length }}人
              <span style="margin: 0px 5px">|</span>舱房：{{
                stateroom.stateroomArea
              }}
              <span style="margin: 0px 5px">|</span> 阳台：{{
                stateroomBalconyArea
              }}
              <span style="margin: 0px 5px">|</span> 房间号:
            </span>
            <span class="">{{
                booking.stateroomNumber == "GTY"
                    ? "随机"
                    : booking.stateroomNumber
              }}</span>
            <span
                style="margin: 0px 5px"
                v-if="booking.stateroomNumber != 'GTY' && !is2021Sailing"
            >|</span
            >
            <template v-if="bookingDetail.showDeckImg == true">
              <a
                  class="showDeck cursor-pointer fw-400"
                  v-if="booking.stateroomNumber != 'GTY' && !is2021Sailing"
                  style="color: #337ab7; cursor: pointer"
                  @click="isShowDeckPopup = true"
              >
                查看甲板图
              </a>
              <GtyTag
                  v-else-if="booking.stateroomNumber == 'GTY'"
                  :targetContainer="'app'"
              />
            </template>
          </div>
          <template v-if="booking.allowFillGuest">
            <div class="booking-fill-guests">
              <div class="fill-guest-tabs-main">
                <ul class="fill-guests-tabs">
                  <li v-for="(guest, i) in guestsShow" :key="('guest_tabs_' + i)" :class="{'is-selected':guest.isSelected}" @click="handleGuestsSwitch(guest,i)">{{guest.passengerName}}</li>
                </ul>
                <div class="fill-guests-prompt">建议开航<span class="fc-red">45</span>天前补全全部乘客信息，开航前<span class="fc-red">7</span>天及以内不可再进行修改</div>
              </div>
              <template v-for="(guest, i) in guestsShow">
                <GuestInfoGuest
                    v-show="guest.isSelected"
                    :guest="guest"
                    :index="guest.idx"
                    :key="('guest_item_' + i)"
                    :tip-show="false"
                    :now-time="nowTime"
                    :onGuestConfirm="onGuestConfirm"
                    :onSelectContactShow="onSelectContactShow"
                    @clearGuest="onClearGuest"
                />
              </template>
            </div>
            <button @click="submitFillGuests" class="booking-fill-guests-btn">提交乘客信息</button>
          </template>
          <div
              class="usr_con"
              v-for="(guest, i) in bookingGuests"
              :key="'guest_' + i"
          >
            <div class="usr_head_con">
              <div class="usr_head">
                <span class="fw-400">
                  <span
                      style="margin-right: 10px"
                      v-if="guest.passengerName"
                  >
                    {{ guest.passengerName }}
                  </span>
                  <span>{{ guest.enPassengerName }}</span>
                </span>
              </div>
              <!-- <div
                  class="text"
                  @click="onChangeGuestPassport(guest)"
                  v-if="
                  !guest.unFilledGuest &&
                  (!guest.passPortNum ||
                  guest.passPortNum.length == 0 ||
                  !guest.passPortExpirationDate ||
                  guest.passPortExpirationDate.length == 0)
                "
              >
                <img
                    class="icon"
                    src="https://resource.rcclchina.com.cn/tui2/order/icon-passport.png"
                />
                <span>补全护照信息</span>
              </div> -->
              <div class="head_rg">费用明细</div>
            </div>
            <div class="info_con">
              <div class="info_lf">
                <div class="det_lf">
                  <div>
                    性别：<span class="text fw-400" v-if="!guest.unFilledGuest">{{ guest.gender == "M" ? "男" : "女" }}</span>
                  </div>
                  <div v-if="guest.dateOfBirthStr && guest.dateOfBirthStr.length >= 10">
                    生日：<span class="text fw-400" v-if="!guest.unFilledGuest">{{ guest.dateOfBirthStr }}</span>
                  </div>
                  <div v-if="guest.telephone">
                    手机：<span class="text fw-400" v-if="!guest.unFilledGuest">{{ guest.telephone }}</span>
                  </div>
                </div>
                <div class="det_lf det_rg">
                  <div>
                    护照号：<span class="text fw-400" v-if="!guest.unFilledGuest">{{ getGuestPassport(guest) }}</span>
                  </div>
                  <div>
                    有效期：<span class="text fw-400" v-if="!guest.unFilledGuest">{{ getPassPortExpirationDate(guest) }}</span>
                  </div>
                  <div>
                    邮箱：<span class="text fw-400" v-if="!guest.unFilledGuest">{{ guest.email }}</span>
                  </div>
                </div>
              </div>
              <div
                  class="info_rg"
                  v-if="guestsPrice && guestsPrice.length > i && isShowPrice"
              >
                <div class="price_con">
                  <div>
                    零售指导价
                    <span class="text fw-400">
                      {{ currency }}
                      {{ guestsPrice[i].originalPrice }}
                    </span>
                  </div>
                  <div>
                    港务税费
                    <span class="text fw-400">
                      {{ currency }}{{ guestsPrice[i].taxPrice }}
                    </span>
                  </div>
                  <div v-if="showGratuities">
                    服务费
                    <span class="text fw-400">
                      {{ currency }}{{ guestsPrice[i].gratuities }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
              class="specialBookinginfo_con"
              v-if="
              bookingPrice &&
              selectBookingGuestSpecials &&
              selectBookingGuestSpecials.length > 0
            "
          >
            <div class="specialBookinginfo_head_con"></div>
            <div class="info_con">
              <div class="specialDet_lf" v-if="isBirthday">
                <div
                    class="specialBookinginfo_title_click"
                    @click="showStateroomSuitePopup(specialBookingImg)"
                >
                  <img
                      class="specialBookinginfo_title_con"
                      src="https://resource.rcclchina.com.cn/wechatMiniProgram/WechatMiniProgramImage/birthdayRoom/birthday_icon.png"
                      alt=""
                  />
                  <span class="specialBookinginfo_text fw-600"
                  >享受收费生日礼遇</span
                  >
                  <img
                      class="specialBookinginfo_ruleDescription_con"
                      src="https://resource.rcclchina.com.cn/tui2/info/webhao.png"
                  />
                </div>
                <div class="specialBookinginfo_info">
                  <div>
                    <span class="fw-600">已选择</span>
                    <span class="text fw-600">{{
                        getSpecialBookingGuestName()
                      }}</span>
                    <span class="fw-600">享受生日礼遇</span>
                  </div>
                  <div>
                    <span class="fw-600">将于</span>
                    <span class="text fw-600">{{
                        getSpecialBookingTimeslot()
                      }}</span>
                    <span class="fw-600">享用生日蛋糕</span>
                  </div>
                </div>
              </div>
              <div class="birthday-right">
                <div>
                  生日礼遇
                </div>
                <div>
                  {{ currency }}{{bookingPrice.priceInfo.specialBirthdayPrice}}
                </div>
              </div>
            </div>
          </div>
          <template v-if="bookingDetail.groupType==='PCPGIFT'">
            <PcpGiftView :giftInfo="bookingDetail.stateroomCategory?.personalizedStateroomInfo"
                         :shipCode="booking.shipCode"
                         :sailDate="booking.sailDate"
                         :guestNumber="bookingDetail.bookingRecordApi?.bookingGuests?.length"
                         @open="showCustomThemePopup"
                         is-on-page-popup
                         pageName="BookingDetail"
                         @getPcpGift="(val)=> pcpGiftInfo = val"></PcpGiftView>
          </template>
          <div
              class="pr_con"
              v-if="bookingPrice && bookingPrice.priceInfo && isShowPrice"
          >
            <div class="price_box">
              <div>
                零售指导价合计
                <span class="text fw-400">
                  {{ currency }}
                  {{ bookingPrice.priceInfo.originalPrice }}
                </span>
              </div>
              <div
                  v-if="
                  bookingPrice &&
                  bookingPrice.prices &&
                  bookingPrice.prices.priceInfo
                "
              >
                船票优惠详情
                <div class="pr_count_con">
                  <div
                      v-for="(priceItem, i) in discountPriceItems"
                      :key="'discount_' + i"
                  >
                    {{ priceItem.description }}
                    <span class="text blue"
                    >-{{ currency
                      }}{{ priceItem.amount.replace("-", "") }}</span
                    >
                  </div>
                </div>
              </div>
              <div v-if="bookingDetail.obcAmount > 0">
                船上消费抵用金<span class="text fw-400"
              >${{ bookingDetail.obcAmount }}</span
              >
              </div>

              <div v-if="bookingDetail.groupType != 'QIAOHU'">
                优惠后船票合计<span class="text fw-400"
              >{{ currency }}{{ discountedPrice }}</span
              >
              </div>
              <div v-if="bookingPrice &&
                         bookingPrice.priceInfo &&
                         bookingPrice.priceInfo.biddingPrice">
                升房费
                <span class="text fw-400">
                  {{ currency }}
                  {{ bookingPrice.priceInfo.biddingPrice }}
                </span>
              </div>
              <div>
                港务税费合计<span class="text fw-400"
              >{{ currency }}{{ bookingPrice.priceInfo.taxPrice }}</span
              >
              </div>
              <div v-if="showGratuities">
                服务费合计<span class="text fw-400"
              >{{ currency }}{{ bookingDetail.gratuities }}</span
              >
              </div>
              <div v-if="isBirthday">
                生日礼遇<span class="text fw-400"
              >{{ currency }}{{bookingPrice.priceInfo.specialBirthdayPrice}}</span
              >
              </div>
              <div v-if="bookingDetail.groupType === 'PCPGIFT' && pcpGiftInfo">
                {{pcpGiftInfo.name}} x{{booking.bookingGuests.length}}<span class="text fw-400">{{ currency }}{{pcpGiftInfo.price}}</span>
              </div>
              <div class="line"></div>
              <div v-if="booking.status != 'CANCELLED'">
                <div v-if="payAmount > 0 && payAmount < booking.amount">
                  已支付订金
                  <span class="text fw-400 red"
                  >{{ currency }}{{ payAmount }}</span
                  >
                </div>
                <div v-if="payAmount > 0 && payAmount < booking.amount">
                  待支付尾款
                  <span class="text fw-400 red"
                  >{{ currency
                    }}{{ Math.round(booking.amount - payAmount) }}</span
                  >
                </div>
                <div>
                  合计<span class="text fw-400 red"
                >{{ currency }}{{showGratuities ? booking.includeGratuities : booking.amount}}</span
                >
                </div>
                <p
                    v-if="
                    payAmount > 0 &&
                    payAmount < booking.amount &&
                    !bookingDetail.canPay
                  "
                >
                  需等待约10个工作日后可支付尾款
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="hsbcBanner" v-if="false">
        <Swiper
            ref="bannerSwiper"
            :options="swiperOptions"
            class="swiper-container swiper-topics topics"
            @click-slide="onShowPopupsImg"
        >
          <SwiperSlide
              v-for="(item, i) in hsbcBanners"
              :key="i"
              class="swiper-slide promoBannerLink external"
          >
            <div  style="width: 100%;height: 100%">
              <img :src="item.image" alt=""/>
            </div>
          </SwiperSlide>
          <div
              ref="swiper-pagination"
              class="swiper-pagination"
              v-if="hsbcBanners.length > 1"
              slot="pagination"
          ></div>
        </Swiper>
      </div>
      <div
          class="line_con choose_pay_con"
          style="margin-bottom: 0"
          v-if="
          booking.status != 'CANCELLED' &&
          !isExpired &&
          (bookingDetail.canPay || booking.localStatus != 10) && !getTikTokCouponStatus(booking.tikTokCouponStatus)
        "
      >
        <div class="pay_title" style="display: flex;gap: 40px">
          选择支付方式
        </div>
        <div class="pay_way_con">
          <div
              class="pay_way_item canSelect"
              :class="{ active: paymentType == 'ALIPAY' }"
              @click="paymentType = 'ALIPAY'"
          >
            <img
                src=" https://resource.rcclchina.com.cn/tui2/order/alipay.png"
            />
          </div>
          <div
              class="pay_way_item canSelect"
              :class="{ active: paymentType == 'WECHATQRCODEPAY' }"
              @click="paymentType = 'WECHATQRCODEPAY'"
          >
            <img
                src=" https://resource.rcclchina.com.cn/tui2/order/wechartpay.png"
            />
          </div>
          <div v-if="bookingDetail?.paymentMethodType !== null && bookingDetail?.paymentMethodType===1"
              class="pay_way_item canSelect"
              :class="{ active: paymentType == 'UNIONPAY' }"
              @click="paymentType = 'UNIONPAY'"
          >
            <img
                src="https://resource.rcclchina.com.cn/cruiseDetail/unionPay.png"
            />
            <span style="color: #000; font-weight: 400; font-size: 16px"
            >银联支付</span
            >
          </div>
          <div
              v-if="bookingDetail?.paymentMethodType !== null && bookingDetail?.paymentMethodType===1"
              class="pay_way_item"
              data-type="offline-pay"
              @click="isShowBankPopup = true"
          >
            <img
                class="offlinePayImage"
                src=" https://resource.rcclchina.com.cn/tui2/order/cardpay.png"
            />
            <span>详情</span>
            <span class="offline-pay-tips">(不推荐)</span>
          </div>
        </div>
      </div>
      <div  v-if="
              bookingDetail.isDownPayCruise &&
              booking.downPay > 0 &&
              bookingPays.length == 0
            " class="deposit-con">
        <div class="deposit-text">
          <img class="deposit-icon" :src="`${imgUrl}/cruiseSearch/icons/deposit-currency-symbol.svg`"/>
          <span>是否使用订金支付</span>
          <img
                  @click="isShowDepositPopup = true"
                  class="det_icon downpay_icon"
                  src=" https://resource.rcclchina.com.cn/tui2/info/webhao.png"
              />
        </div>
        <div class="deposit-select">
          <RcclCheckBox v-on:onChanged="onDepositChanged" />
          <span>订金费用¥1000/人起</span>
        </div>
      </div>
    
      <div
          class="order_ft_con"
          style="margin-bottom: 10px"
          v-if="
          booking.status != 'CANCELLED' &&
          !isExpired &&
          (bookingDetail.canPay || booking.localStatus != 10) && !getTikTokCouponStatus(booking.tikTokCouponStatus)
        "
      >
        <div class="ft_lf">
          <div class="unpaid_rg">
            <div>
              <span class="total-text" v-if="payAmount < booking.amount"
              >应付尾款总计：</span
              >
              <span class="total-text" v-else>应付总计：</span>
              <span class="text">
                <span class="text-currency">{{ currency }}</span>
                <span id="netAmountText">{{ shouldPayAmount }}</span>
              </span>
            </div>
          </div>
          <!-- <div
              class="unpaid_lf checkBox"
              v-if="
              bookingDetail.isDownPayCruise &&
              booking.downPay > 0 &&
              bookingPays.length == 0
            "
          >
            <RcclCheckBox v-on:onChanged="onDepositChanged" />
            <span class="unpaid_lf_text"
            >支付订金&nbsp;
              <img
                  @click="isShowDepositPopup = true"
                  class="det_icon downpay_icon"
                  src=" https://resource.rcclchina.com.cn/tui2/info/webhao.png"
              />&nbsp;订金费用&nbsp;￥{{ booking.downPay }}</span
            >
          </div> -->
          <div v-if="bookingDetail.bookingIntegral && bookingDetail.bookingIntegral.integral > 0" class="integral_lf">
            <PointGiveaway :point="integral" :isFinishSelfInfo="isFinishSelfInfo"></PointGiveaway>
          </div>
<!--          <div-->
<!--              class="un_jifen"-->
<!--              v-if="-->
<!--              bookingDetail.bookingIntegral &&-->
<!--              bookingDetail.bookingIntegral.integral > 0-->
<!--            "-->
<!--          >-->
<!--            当前订单预计赠送<span>{{ integral }}</span-->
<!--          >积分-->
<!--            <IntegralTag :index="booking.bookingId" />-->
<!--            &lt;!&ndash; <br />-->
<!--            可至积分商城兑换价值约<span>{{-->
<!--              bookingDetail.bookingIntegral.valuation-->
<!--            }}</span-->
<!--          >元电话卡 &ndash;&gt;-->
<!--          </div>-->
        </div>
        <div class="ft_rg" id="goToPay" @click="submitPayment">立即支付</div>
      </div>

      <template v-if="booking.isRow == false">
        <div
            class="shore_excursion"
            v-if="
            canShorex &&
            booking.status != 'CANCELLED' &&
            (selectedShorex || booking.localStatus == 10)
          "
        >
          <div class="shore_title">岸上观光服务</div>

          <div
              class="shore_notice"
              v-if="!selectedShorex && shorexes.length == 0"
          >
            <div></div>
            <div class="notice_1" style="text-align: left;cursor: pointer">
              您可以在支付完成后界面选择岸上观光服务，或在船票预订完成后前往皇家行前订网站小程序选订。<br/>
              您也可以不选订任何行程则视为自助游，您需自行安排目的地游览行程。
  <!--            该航次岸上观光服务尚未开放选订，选订开放后，我们会在第一时间通知您。您也可以密切关注皇家加勒比官方网站，后续可至<span @click="goToPcp" style="color: #016bba">>>皇家行前订</span>进行预订。-->
            </div>
          </div>
          <div v-else-if="!selectedShorex && shorexes.length > 0">
            <div class="selectShorex-css">
              <div>尊敬的客人，您尚未预订任何岸上观光行程。皇家官方为您提供多种岸上观光行程，您可至>><span @click="goToPcp" class="up-shorex">皇家行前订</span>自主进行选订。</div>
              <div>如不进行任何行程选订则视为自助游，您需自行安排目的地游览行程。</div>
            </div>
          </div>
          <div v-else>
            <div v-if="selectedShorex && selectedShorex.shorexType == 1">
              <div class="shore_subtitle">皇家常规游 (免费)</div>
              <ul>
                <li
                    v-for="(tour, j) in selectedShorex.shorexTrips"
                    :key="'tour_' + j"
                >
                  <div class="shore_intro shorex_free f-fl">
                    <div class="shore_sight">
                      {{ tour.tripName }} - {{ tour.tripTime }}
                    </div>
                    <div class="shore_t" v-html="tour.description"></div>
                  </div>
                </li>
              </ul>
            </div>
            <div v-else-if="selectedShorex">
              <div class="shore_subtitle">{{ selectedShorex.shorexName }}</div>
              <ul>
                <li
                    v-for="(tour, j) in selectedShorex.shorexTours"
                    :key="'tour_' + j"
                >
                  <img class="shore_img f-fl" :src="tour.image" />
                  <div class="shore_intro f-fl">
                    <div class="shore_sight">{{ tour.shorexName }}</div>
                    <div class="shore_t">{{ tour.shorexBrief }}</div>
                    <div class="shore_time">
                      <div class="com">
                        <span>时&nbsp;长：</span>
                        <span class="com_bold">{{ tour.duration }}</span>
                      </div>
                      <div class="com">
                        <span>数&nbsp;量：</span>
                        <span class="com_bold">{{ bookingGuests.length }}</span>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
            <div class="shore_notice has_shorex_notice" v-if="selectedShorex">
              <div>注:</div>
              <div class="notice_1">
                <span class="parah-num">1)</span
                >目的地的产品及行程仅供参考，实际行程以具体航次和地接社安排为准。
              </div>
              <div class="notice_1">
                <span class="parah-num">2)</span
                >目的地产品及行程可能受天气、航次情况、交通、政府政策及/或保护公共健康安全之相关要求而取消、变更或调整。
              </div>
              <div class="notice_1">
                <span class="parah-num">3)</span
                >皇家行前订目前只提供全程观光套餐，您可于登船后购买单一港口观光产品，全程套餐与单一港口观光产品均数量有限，先到先得。
              </div>
  <!--            <div class="notice_1">-->
  <!--              <span class="parah-num">3)</span-->
  <!--              >关于岸上观光产品的咨询、预订和修改，您可以拨打400-820-3187和皇家加勒比游轮度假专家联系。-->
  <!--            </div>-->
              <!-- <div class="notice_1">1)  航程与时长仅供参考,以地接社实际为准。</div>
              <div class="notice_1">2)  关于岸上观光产品的咨询、预定和修改,您可拨打400-820-3187 和皇家加勒比游轮度假专家联系。</div> -->
              <div
                  class="total"
                  v-if="bookingGuests.length > 0 && selectedShorex.price > 0"
              >
                合计
                <span class="money" style="color: #ff3022">
                  {{ bookingGuests.length * selectedShorex.price }} 美元</span
                >
              </div>
            </div>
            <div class="shore_notice" v-else-if="shorexes.length > 0">
              <div class="notice_1">您尚未预定任何岸上观光服务</div>
            </div>
            <div
                class="modify_sight not_selected_shorex"
                @click="isShowShorexPopup = true"
                v-if="
                !selectedShorex &&
                shorexes.length > 0 &&
                (booking.localStatus == 10 || booking.status == 'BOOKED')
              "
            >
              请选择
            </div>
            <div
                class="modify_sight has_shorex_notice"
                @click="isShowShorexPopup = true"
                v-else-if="
                selectedShorex &&
                selectedShorex.shorexType == 1 &&
                shorexes.length > 0 &&
                (booking.localStatus == 10 || booking.status == 'BOOKED')
              "
            >
              升级精品游
            </div>
            <div
                class="modify_sight has_shorex_notice"
                v-else-if="
                shorexes.length > 0 &&
                (booking.localStatus == 10 || booking.status == 'BOOKED')
              "
                @click="isShowShorexPopup = true"
            >
              修改精品游
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <div
            class="shore_excursion"
            
        >
          <div class="shore_title">关于海外航线“预付费类”船上产品或服务的重要说明：</div>

          <div
              class="selectShorex-css"
          >
            <div>
              由于技术限制，皇家加勒比国际游轮旗下海外出发航线的船上付费项目暂时无法在皇家行前订官网以及国际官网提前预订和支付（船上付费类项目通常包括：海外目的地的岸上观光，船上各类付费餐饮、娱乐等），请您于登船后进行预订。
            </div>
          </div>
          
        </div>
      </template>

      <!---皇家行前订-->
      <template v-if="booking.isRow == false">
        <BookingDetailPcp
            v-if="booking.status == 'BOOKED' || booking.localStatus == 10"
            :pcpOrder="bookingDetail.pcpOrderViewModel"
            :booking="booking"
        />
      </template>

      <!-- 发票说明 -->
      <div class="line_con choose_pay_con" v-if="booking.isRow == false">
        <div class="line-intro">
          <div class="pay_title">发票说明</div>
          <div class="pay_text">
            <p>
              1）官网预订仅可开具增值税普通发票，无法开具增值税专用发票。发票内容为“旅游服务·船票款”，不得进行修改。航次结束3个月后不得申请该航次所属的发票。
            </p>
            <p>
              2）官方线下渠道使用美金支付的船票款只能开具形式发票。其它船上消费因已属境外消费，需要找船上开具账单。
            </p>
            <p>
              3）个人付款可开具个人抬头发票，公司转款可开具公司抬头发票（请务必通过公司账户银行转账）。个人付款如需开具公司抬头发票，需提供公司名称、税号等必要的开票信息。
            </p>
            <p>
              4）如因订单内容变更总金额发生变动、需要重新开发票的，预订人需先退回原发票后方可开具新的发票。
            </p>
          </div>
        </div>
      </div>

      <!-- 游轮保险 -->
      <div
          class="line_con choose_pay_con"
          v-if="visaContent && visaContent.insuranceContent"
      >
        <div class="line-intro">
          <div class="pay_title">游轮保险</div>
          <div class="pay_text" v-html="visaContent.insuranceContent"></div>
        </div>
      </div>

      <!-- 游轮保险 -->
      <div class="line_con choose_pay_con" v-if="isBirthday">
        <div class="line-intro">
          <div class="pay_title">生日礼遇退改规则</div>
          <div class="pay_text">
            <p>
              开航前7天（不含）之前，可以免费修改生日礼遇的乘客信息（仅限同舱内）、调整享用生日蛋糕的用餐时间或取消生日礼遇；开航前7天之内，不再接受任何修改或取消，已收取的费用不予退回
              。
            </p>
          </div>
        </div>
      </div>

      <div class="line_con choose_pay_con" v-if="booking.isRow == false">
        <div class="line-intro">
          <div class="pay_title">办理登船注意事项</div>
          <div class="pay_text">
            1）支付成功后，将需要3个工作日左右对您的订单进行确认及系统操作，订单确认后，请务必在开航7天之前办理
            <a
                href="https://www.rcclchina.com.cn/olci/Rccl.Olci/Olci/CheckInIndex"
                class="rule-item-link external"
                target="_blank"
            >
              在线值船 </a
            >，
            打印“登船证”并于登船当天携带。<!--如遇紧急情况，请您拨打皇家客服专线：400-820-7195。-->
          </div>
          <div class="pay_text">
            2）码头办理登船时间为登船当日{{
              bookingDetail.boardingTime
            }}，请您务必按照登船证的“指定到达时间”内抵达码头办理登船，否则将影响您的出行。每个航次的具体登船时间请以出行前短信通知为准。
          </div>
          <div class="pay_text" style="display: flex">
            3）码头地址：<div v-html="bookingDetail.portAddress"></div>
          </div>
          <div class="pay_text">
            4）了解更多游轮行前准备及出行指南，请查看并下载
            <a
              style=""
              target="_blank"
              v-if="(booking.cruisePartRecordView && booking.cruisePartRecordView.cruiseRoute.indexOf('香港') == 0)"
              href="https://resource.rcclchina.com.cn/PDF/%E7%9A%87%E5%AE%B6%E9%81%8A%E8%BC%AA%E5%81%87%E6%9C%9F-%E6%B5%B7%E6%B4%8B%E5%85%89%E8%AD%9C%E8%99%9F%E9%A6%99%E6%B8%AF%E8%88%AA%E6%AC%A1%20%EF%BC%88CH%20%20EN%EF%BC%89-1.pdf"
            >
              皇家游轮出行指南
            </a>
            <a
              style=""
              target="_blank"
              v-else-if="(booking.shipCode == 'SC')"
              href="https://resource.rcclchina.com.cn/HM/%E9%A6%96%E9%A1%B5Banner/%E6%B5%B7%E6%B4%8B%E5%85%89%E8%B0%B1%E5%8F%B7%20-%20%E4%B8%8A%E6%B5%B7%E6%AF%8D%E6%B8%AF%E8%A1%8C%E5%89%8D%E6%89%8B%E5%86%8C.pdf"
            >
              皇家游轮出行指南
            </a>
            <a
                style=""
                target="_blank"
                v-else
                href="https://www.rcclchina.com.cn/media/default/images/Royal_Cruise_Vacation-QN.pdf"
            >
              皇家游轮出行指南
            </a>
          </div>
        </div>
      </div>
      <div class="line_con choose_pay_con" v-else>
        <div class="line-intro">
          <div class="pay_title">办理登船注意事项</div>
          <div class="pay_text">
            1）支付成功后，将需要3个工作日左右对您的订单进行确认及系统操作，订单确认后，请务必在开航日前45天至72小时前办理
            <a
                href="https://www.royalcaribbean.com/account/signin?cS=NAVBAR&wuc=CHN"
                class="rule-item-link external"
                target="_blank"
            >
              在线值船 </a
            >，
            打印“登船证”并于登船当天携带。
          </div>
          <div class="pay_text">
            2）码头办理登船时间：请按照您在线值船时预约的时间段，准时抵达码头办理登船。
          </div>
          <div class="pay_text" style="display: flex">
            3）码头地址：<div v-html="bookingDetail.portAddress"></div>
          </div>
          
        </div>
      </div>
    </div>

    <StateroomDetail
        :isShow="isShowStateroomDetailPopup"
        :stateroomDetail="selectStateroom"
        :isFortyEightHoursNrpCruise="bookingDetail.isFortyEightHoursNrpCruise"
        :showQiaohuPopup="showQiaohuPopup"
        :showStarrySkyPopup="showStarrySkyPopup"
        :showCustomThemePopup="showCustomThemePopup"
        v-on:onModalClose="isShowStateroomDetailPopup = false"
        :showRow="booking.isRow"
    />

    <StateroomDetailSuite
        :isShow="isShowStateroomDetailSuitePopup"
        :stateroomDetail="selectStateroom"
        :isFortyEightHoursNrpCruise="bookingDetail.isFortyEightHoursNrpCruise"
        v-on:onModalClose="isShowStateroomDetailSuitePopup = false;"
        :showRow="booking.isRow"
    />

    <BookingDeckPopup
        v-if="booking.stateroomNumber != 'GTY' && !is2021Sailing"
        :isShow="isShowDeckPopup"
        :shipCode="booking.shipCode"
        :sailDate="booking.sailDate"
        :deckNumber="booking.deckCode"
        v-on:onModalClose="isShowDeckPopup = false"
    />

    <DepositPopup
        :isShow="isShowDepositPopup"
        v-on:onModalClose="isShowDepositPopup = false"
        :isNrp="booking.isnrp"
    />

    <BankPopup
        :isShow="isShowBankPopup"
        :bankTransferInfo="bankTransferInfo"
        v-on:onModalClose="isShowBankPopup = false"
    />

    <BookingDetailShorex
        :isShow="isShowShorexPopup"
        :shorexes="shorexes"
        v-on:onModalClose="isShowShorexPopup = false"
        :booking="booking"
        :onSelectShorex="onSelectShorex"
    />

    <ConnectRoomPopup
        :isShow="isShowConnectRoomPopup"
        v-on:onModalClose="isShowConnectRoomPopup = false"
    />

    <QiaohuPopup
        :isShow="isShowQiaohuPopup"
        :shipCode="booking.shipCode"
        :sailDate="booking.sailDate"
        v-on:onModalClose="isShowQiaohuPopup = false"
    />

    <StarrySkyPopup
        :isShow="isShowStarrySkyPopup"
        :shipCode="booking.shipCode"
        :sailDate="booking.sailDate"
        v-on:onModalClose="isShowStarrySkyPopup = false"
    />
    <CustomThemePopup
      :isShow="isShowCustomThemePopup"
      :themeInfo="personalizedStateroomInfo"
      v-on:onModalClose="isShowCustomThemePopup = false"
    />

    <ChangeBookingContact
        :isShow="isShowChangeContactPopup"
        :contact="targetContact"
        :changeContact="onContactChanged"
        :bookingId="booking.encBookingId"
        v-on:onModalClose="isShowChangeContactPopup = false"
    />

    <GuestPassportPopup
        :isShow="isShowGuestPassportPopup"
        :guest="targetGuest"
        v-on:onModalClose="isShowGuestPassportPopup = false"
        :onGuestPassportChange="onGuestPassportChange"
    />

    <!-- <SpecialBookinginfoPopup
        :newRuleDescription="specialBookingRuleDescription"
        :isShow="isShowSpecialBookinginfoPopup"
        v-on:onModalClose="closeSpecialBookinginfoPopup"
    /> -->

    <SuiteStateroomPopup
        :suiteImage="suiteImage"
        v-on:onModalClose="closeStateroomSuitePopup"
        :isShow="isShowSuitePopup"
    />

    <SelectContact
        v-if="isShowSelectContact"
        is-desc
        :style="selectContactPosition"
        :isFill="true"
        :onClose="onSelectContactClose"
        :limit="selectContactLimit"
        :bookingLimit="guestFillNum"
        :onContactConfirm="onSelectContactConfirm"
    />
    <PopupsImg v-show="isShowPopupsImg"
                :imgUrl="popupsImgUrl"
                @closePopups="onClosePopups"/>
    <StateRoomQrCodePopup v-if="isShowWxQrCodePopup"
                          :wxQrCodeUrl="wxQrCodeUrl"
                          @closePopup="closeWxQrCodePopup"
    ></StateRoomQrCodePopup>
  </div>
</template>

<script>
import bookingHelper from '@/utilities/bookingHelper'
import api from "@/api";
import moment from "moment";
import nrpConfig from "@/utilities/nrpConfig";
import _ from "lodash";
import {checkTel, numberWithCommas} from "@/utilities/tools";
import { SpecialBookingType } from "@/utilities/specialBookingHelper";
import { Swiper, SwiperSlide, directive} from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import StarrySkyPopup from "@/components/Cruise/CruiseDetail/StarrySkyPopup.vue";
import PointGiveaway from "@/components/Booking/PointGiveaway.vue";
import StateRoomQrCodePopup from "@/components/Booking/StateRoomQrCodePopup.vue";
import CustomThemePopup from "@/components/Cruise/CruiseDetail/CustomThemePopup.vue";
import PcpGiftView from "@/components/PCP/PcpGiftView.vue";
import CruisePortsPopup from "@/components/Booking/CruisePortsPopup.vue";
const PopupsImg  = () => import("@/components/Cruise/popupsImg.vue");
const RcclCheckBox = () => import("@/components/Common/RcclCheckBox");
const StateroomDetail = () => import("@/components/Booking/StateroomDetail");
const StateroomDetailSuite = () => import('@/components/Booking/StateroomDetailSuite')
const BankPopup = () => import("@/components/Booking/BankPopup");
const DepositPopup = () => import("@/components/Booking/DepositPopup");
const ConnectRoomPopup = () => import("@/components/Cruise/CruiseDetail/ConnectRoomPopup");
const QiaohuPopup = () => import("@/components/Cruise/CruiseDetail/QiaohuPopup");
const BookingDeckPopup = () => import("@/components/Booking/BookingDeckPopup");
const NrpTag = () => import("@/components/Booking/NrpTag");
const GtyTag = () => import("@/components/Booking/GtyTag");
const BookingDetailShorex = () => import("@/components/Booking/BookingDetail/BookingDetailShorex");
const BookingDetailPcp = () => import("@/components/Booking/BookingDetail/BookingDetailPcp");
const ChangeBookingContact = () => import("@/components/Booking/BookingDetail/ChangeBookingContact");
const GuestPassportPopup = () => import("@/components/Booking/GuestPassportPopup");
const SuiteStateroomPopup = () => import("@/components/Cruise/CruiseDetail/SuiteStateroomPopup.vue");
const GuestInfoGuest = () => import('@/components/Booking/GuestInfo/GuestInfoGuest')
const SelectContact = () => import('@/components/Booking/GuestInfo/SelectContact')
const PrivacyButton = () => import("@/components/Common/PrivacyButton")

export default {
  name: "BookingDetail",
  components: {
    PcpGiftView,
    CustomThemePopup,
    CruisePortsPopup,
    StateRoomQrCodePopup,
    PointGiveaway,
    StarrySkyPopup,
    PopupsImg,
    Swiper,
    SwiperSlide,
    RcclCheckBox,
    StateroomDetail,
    StateroomDetailSuite,
    BookingDeckPopup,
    BankPopup,
    NrpTag,
    GtyTag,
    DepositPopup,
    BookingDetailShorex,
    BookingDetailPcp,
    ConnectRoomPopup,
    QiaohuPopup,
    ChangeBookingContact,
    GuestPassportPopup,
    SuiteStateroomPopup,
    GuestInfoGuest,
    SelectContact,
    PrivacyButton
  },
  directives: {
    swiper: directive,
  },
  data() {
    return {
      isHidePage: true,
      bookingDetail: {},
      selectStateroom: {},
      targetContact: {},
      isShowShorexPopup: false,
      isShowVisaPopup: false,
      isShowDeckPopup: false,
      isShowBankPopup: false,
      isShowStateroomDetailPopup: false,
      isShowStateroomDetailSuitePopup: false,
      isShowGtyTips: false,
      isShowConnectRoomPopup: false,
      isShowQiaohuPopup: false,
      isShowDepositPopup: false,
      paymentType: "ALIPAY",
      isSelectDeposit: false,
      isShowChangeContactPopup: false,
      isShowGuestPassportPopup: false,
      targetGuest: {},
      isShowSpecialBookinginfoPopup: false,
      specialBookingRuleDescription: "",
      suiteImage: "",
      isShowSuitePopup: false,
      isShowStarrySkyPopup: false,
      isShowSelectContact: false,
      selectContactTarget: {
        element: {},
        index: -1
      },
      guests: [],
      guestsShow: [],
      currentGuestIdx: 0,
      nowTime: 0,
      guestFillNum: -1,
      showGratuities: false,
      swiperOptions: {
        pagination: {
          el: ".swiper-pagination",
        },
        loop: false,
        autoplay: {
          delay: 5000,
        },
      },
      hsbcBanners:null,
      popupsImgUrl:'',
      isShowPopupsImg:false,
      bookingState:false,  //订单状态
      isShowWxQrCodePopup:false,
      wxQrCodeUrl: '',
      bankTransferInfo: {
        popupBoxType:1,// 1显示默认弹框 2.显示临近航线弹框（显示ShowFinalPaymentTime字段）
        showFinalPaymentTime:'' 
      },
      isShowCustomThemePopup: false,
      personalizedStateroomInfo: null,
      pcpGiftInfo: null,
      imgUrl: process.env.VUE_APP_IMG_URL,
    };
  },
  beforeMount() {
    this.initPage();
  },
  beforeDestroy() {},
  methods: {
    test() {
      this.$router.go(0)
    },
    async initPage() {
      const userToken = this.$store.state.user.userToken;
      if (!userToken || userToken.length == 0) {
        return this.$router.push({
          name: "Login",
          query: {
            returnUrl: encodeURIComponent(location.href),
          },
        });
      }
      this.$store.dispatch("GET_USER_CONTACTS", userToken);

      const query = this.$router.currentRoute.query;
      if (!query || !query.bookingId || query.bookingId == "") {
        return this.$router.push({ name: "BookingSearch" });
      }
      this.selectStateroom = {};
      this.$loading.show();
      const { success, data, errMsg } = await api.booking.bookingDetail({
        // 使用加密字段encBookingId
        encBookingId: query.bookingId,
        userName: userToken,
      });
      this.$loading.hide();
      if (!success) {
        console.error(errMsg);
      } else {
        this.bookingDetail = data;
        this.targetContact = this.bookingDetail.bookingRecordApi.bookingContacts[0] || {};
        this.isHidePage = false;
        this.showGratuities = this.bookingDetail.hasGratuities;
        this.guests = this.getGuests(data.bookingRecordApi);
        this.guestsShow = JSON.parse(JSON.stringify(this.guests));
        if (data.nationalityApiViews && data.nationalityApiViews.length > 0) {
          this.$store.commit("SET_COUNTRIES", data.nationalityApiViews);
        }
        this.bankTransferInfo.popupBoxType = data.popupBoxType;
        this.bankTransferInfo.showFinalPaymentTime = data.showFinalPaymentTime;
      }
      await this.getCruiseBanner()
    },
    getGuests(record) {
      let rows = [];
      record.bookingGuests.forEach((item,idx)=>{
        let newItem;
        record.bookingGuestExts.forEach(extItem=>{
          if(item.id === extItem.id) {
            newItem = extItem;
            item.unFilledGuest = extItem.unFilledGuest;
            item.passengerName = extItem.passengerName;
            item.enPassengerName = extItem.enPassengerName;
          }
        });
        if(newItem.unFilledGuest) {
          let row = {
            idx: idx,
            birthplace: null,
            callingCode: "86",
            chineseFirstName: null,
            chineseLastName: null,
            createdDate: null,
            dateOfBirth: null,
            email: null,
            firstName: null,
            gender: null,
            guestRef: null,
            guestId: item.id,
            encGuestId: item.encGuestId,  // 新增加密字段encGuestId
            id: null,
            issueAt: null,
            issuingDate: null,
            lastName: null,
            lastUpdateShorexDate: null,
            loyaltyId: "0",
            nationality: "CN",
            passPortExpirationDate: null,
            passPortNum: null,
            passengerName: newItem.passengerName,
            enPassengerName: newItem.enPassengerName,
            passport: null,
            passportExpiresIn: null,
            pinYinFirstName: null,
            pinYinLastName: null,
            pyFirstName: null,
            pyLastName: null,
            remark: null,
            rewardLoyaltyId: "",
            telephone: null,
            unFilledGuest: newItem.unFilledGuest
          }
          rows.push(row);
        }
      });
      rows.forEach((r,idx)=> {r.isSelected = idx === 0; r.isEdit = false})
      return rows;
    },
    getGuestPrice(index) {
      if (this.guestsPrice.length <= index) return {};
      return this.guestsPrice[index];
    },
    onSelectShorex(shorex) {
      this.bookingDetail.selectedShorex = shorex;
      this.isShowShorexPopup = false;
    },
    // 客房详情
    showStateroomDetailPopup() {
      if (this.stateroom) {
        console.log(this.stateroom)
        let stateroomTag = this.booking.stateroomPartView.suiteType;
        let stateroomType = this.booking.stateroomPartView.stateroomClassPartRecord.stateroomType;
        this.selectStateroom = {
          stateroomImages: this.stateroom.stateroomImages,
          stateroomName: this.stateroom.stateroomCNName,
          stateroomCategory: this.stateroom.stateroomCategoryCode,
          stateroomPriceType: this.nrp.priceType,
          stateroomPrice: 0,
          stateroomCapacity: this.stateroom.stateroomCapacity,
          stateroomArea: this.stateroom.stateroomArea,
          stateroomBalcony: this.stateroom.stateroomBalconyArea,
          stateroomFloor: "",
          groupType: this.bookingDetail.groupType,
          stateroomDescription: this.stateroom.stateroomDescription,
          stateroomNrpTitle: this.nrp.title,
          stateroomNrpText: this.nrp.description,
          suiteMobileImageUrl: this.stateroom.suiteMobileImageUrl,
          stateroomShelter: this.bookingDetail.stateroomShelter,
          stateroomTag: stateroomTag || null,
          stateroomType: stateroomType || null,
          isNrp: this.booking.isnrp,
          deviceFeatureTags: this.bookingDetail.featureDeviceTags,
          deviceGroupTags: this.bookingDetail.deviceTags,
          isQiaohu: this.bookingDetail.groupType == 'QIAOHU',
          isStarrySky: this.bookingDetail.groupType == 'STARRYSKY',
          isPcpGiftTheme: this.bookingDetail.groupType == 'PCPGIFT',
          isCustomTheme: this.bookingDetail.groupType == 'CUSTOM',
          personalizedStateroomInfo: this.bookingDetail.stateroomCategory.personalizedStateroomInfo,
          stateroomImageDataList: this.bookingDetail.stateroomCategory.stateroomImageDataList,
          suiteType: this.bookingDetail.stateroomCategory.suiteType,
          roomSummaryList: this.bookingDetail.stateroomCategory.roomSummaryList || [],
          suiteRightsCount: this.bookingDetail.stateroomCategory.suiteRightsCount
        };
        if(this.bookingDetail.groupType == "QIAOHU" || this.bookingDetail.groupType == "STARRYSKY" || this.bookingDetail.groupType == "PCPGIFT" || this.bookingDetail.groupType == "CUSTOM") {
          this.isShowStateroomDetailPopup = true;
        } else {
          this.isShowStateroomDetailSuitePopup = true;
        }
      }
    },
    showBookingIntegralTips() {
      this.$alert.show(
          "积分将于下船后约10天发放至本账户，可在积分商城【积分明细】查看。",
          {
            button: "我知道了",
          }
      );
    },
    getGuestPassport(guest) {
      // if (guest.passPortNum && guest.passPortNum.length >= 5) {
      //   return (
      //     guest.passPortNum.substr(0, 2) +
      //     "*****" +
      //     guest.passPortNum.substr(guest.passPortNum.length - 2, 2)
      //   );
      // } else if (guest.passPortNum && guest.passPortNum.length > 0) {
      //   return "*****";
      // } else {
      //   return "";
      // }
      return guest.passPortNum;
    },
    getPassPortExpirationDate(guest) {
      // if (
      //   !guest.passPortExpirationDate ||
      //   guest.passPortExpirationDate.length == 0
      // ) {
      //   return "";
      // } else if (guest.passPortExpirationDate.length < 10) {
      //   return guest.passPortExpirationDate;
      // } else {
      //   return guest.passPortExpirationDate.substring(0, 10);
      // }
      if (!guest.passPortExpirationDateStr || guest.passPortExpirationDateStr.length == 0) {
        return "";
      } else {
        return guest.passPortExpirationDateStr;
      }
    },
    onDepositChanged(isChecked) {
      this.isSelectDeposit = isChecked;
    },
    onChangeGuestPassport(guest) {
      this.targetGuest = guest;
      this.isShowGuestPassportPopup = true;
    },
    getSpecialBookingInfo(guest) {
      const newGuest =
          this.selectBookingGuestSpecials.find((r) => r.guestId == guest.id) ||
          {};
      return newGuest;
    },
    // 去支付
    async submitPayment() {
      let bookingPayment = {
        // 这里需要使用加密字段encBookingId
        encBookingId: this.booking.encBookingId,
        downPayment: "",
        // 这里需要使用加密字段encBookingRecordId
        encBookingRecordId: this.booking.encBookingRecordId,
      };
      if (
          this.bookingDetail.isDownPayCruise &&
          this.bookingPays.length == 0 &&
          this.isSelectDeposit
      ) {
        bookingPayment.downPayment = "DOWNPAYMENT_" + this.booking.bookingId;
      } else {
        bookingPayment.downPayment = "NULL";
      }
      const bookingPayments = [bookingPayment];

      let paymentType = this.paymentType + "";
      const request = {
        encBookingId: bookingPayments.map((r) => r.encBookingId).join(","),
        paymentType: bookingPayments.map((r) => r.downPayment).join(","),
        payMethod: paymentType,
      };
      await this.checkBookingStates(bookingPayments)
      if(!this.bookingState) return
      this.$loading.show();
      const { success, data, errMsg } = await api.booking.payByMethodHP(
          request
      );
      this.$loading.hide();
      if (!success) {
        this.$alert.show(errMsg);
      }
      if (data && data.checkoutShape && data.checkoutShape.length > 0) {
        this.$router.push({
          name: "PayByMethod",
          params: {
            paymentContent: data,
            paymentType: paymentType,
            orderId: data.orderId,
            requestId: data.requestId,
            bookingIds: data.bookingIds,
            totalAmount: data.totalAmount,
          },
        });
      }
    },
    // 获取订单状态
    async checkBookingStates(bookingPayments) {
      const stateParam = {
        encBookingRecordId:''
      }
      console.log(bookingPayments)
      for (const r of bookingPayments) {
        if (r.encBookingRecordId) {
          stateParam.encBookingRecordId = r.encBookingRecordId;
          this.$loading.show();
          const res = await api.booking.getPayBookingState(stateParam);
          this.$loading.hide()
          if (!res.data.isBookingValid) {
            this.bookingState = false;
            this.$alert.show(res.errMsg);
            return
          }
          this.bookingState = true; // 订单状态
        }
      }
    },
    onContactChanged() {
      // this.targetContact = contact;
      this.isShowChangeContactPopup = false;
      location.reload();
    },
    onGuestPassportChange(guest) {
      this.isShowGuestPassportPopup = false;
      let bookingGuest = this.bookingGuests.find((r) => r.id == guest.id);
      if (bookingGuest) {
        bookingGuest.passPortNum = guest.passPortNum;
        bookingGuest.passPortExpirationDate = guest.passPortExpirationDate;
        bookingGuest.passPortExpirationDateStr = guest.passPortExpirationDate;
      }
    },

    showStateroomSuitePopup(suiteImage) {
      if (suiteImage && suiteImage.length > 0) {
        this.suiteImage = suiteImage;
        this.isShowSuitePopup = true;
      }
    },
    closeStateroomSuitePopup() {
      this.isShowSuitePopup = false;
    },
    getSpecialBookingGuestName() {
      var name = "";
      var index = 0;
      if (
          this.selectBookingGuestSpecials != null &&
          this.selectBookingGuestSpecials.length > 0
      ) {
        this.selectBookingGuestSpecials.forEach((element) => {
          if (index == 0) {
            if (element.guestName) {
              name = element.guestName;
            } else {
              name = element.guestEnName;
            }
          } else {
            if (element.guestName) {
              name += "、" + element.guestName;
            } else {
              name += "、" + element.guestEnName;
            }
          }
          index++;
        });
      }
      return name;
    },
    getSpecialBookingTimeslot() {
      if (
          this.selectBookingGuestSpecials != null &&
          this.selectBookingGuestSpecials.length > 0
      ) {
        const selectBookingGuestSpecial = this.selectBookingGuestSpecials.find(
            (p) => p.specialBookingTimeslot != "" && p.specialBookingPlace != ""
        );
        if (selectBookingGuestSpecial && selectBookingGuestSpecial != null) {
          return (
              selectBookingGuestSpecial.specialBookingDate +
              "  " +
              selectBookingGuestSpecial.specialBookingTimeslot +
              "  " +
              selectBookingGuestSpecial.specialBookingPlace
          );
        }
      }
      return "";
    },
    onSelectContactShow (e, index) {
      if (this.contacts && this.contacts.length > 0) {
        this.selectContactTarget.element = e.target
        this.selectContactTarget.index = index
        this.isShowSelectContact = true
      }
    },
    onSelectContactClose () {
      this.selectContactTarget.element = null
      this.selectContactTarget.index = -1
      this.isShowSelectContact = false
    },
    onSelectContactConfirm (guests) {
      if (guests.length === 0) return;
      // 第一条数据给当前选中的选项卡
      this.setGuestInfo(this.guestsShow[this.currentGuestIdx], guests[0]);
      // 当前选中用户信息大于1条进行处理
      if(guests.length > 1) {
        let idxArr = [];
        // 获取可以填写乘客信息index集合
        this.guestsShow.forEach((guest, idx) => {
          if(!guest.isEdit && this.currentGuestIdx !== idx) return idxArr.push(idx);
        });
        // 遍历index集合，将空位用户信息补全（当前选中集合从第二条数据加入）
        for(let i = 0; i < idxArr.length; i++) {
          console.log(this.guestsShow[idxArr[i]])
          this.setGuestInfo(this.guestsShow[idxArr[i]], guests[i+1]);
        }
      }
      this.guestFillNum = this.guestsShow.filter(r=>r.isEdit === false).length;
      this.nowTime = new Date().getTime();
      // console.log(guests)
      // console.log(obj)
      // this.guests.forEach(r => { r.isSelected = false; });
      // this.guests[idx].isSelected = true;
      // this.guests[idx] = Object.assign({},obj);
      // console.log(this.guests[idx])
      // console.log(this.guests);
      // this.$forceUpdate();
      // if (this.selectContactTarget.index >= 0) {
      //   for (let i = 0; i < guests.length; i++) {
      //     this.guests[this.selectContactTarget.index] = guests[i];
      //     console.log(this.guests[this.selectContactTarget.index]);
      //   }
      //   for (let i = 0; i < guests.length; i++) {
      //     if (this.guests.length > i + this.selectContactTarget.index) {
      //       //覆盖乘客前判断原先乘客是否已经勾选特殊礼遇
      //       if(this.guests[i+this.selectContactTarget.index].specialBookingOrder != null){
      //         guests[i].specialBookingOrder = this.guests[i+this.selectContactTarget.index].specialBookingOrder
      //         this.guests[i+this.selectContactTarget.index] = guests[i]
      //       }else{
      //
      //         this.guests[i+this.selectContactTarget.index] = guests[i]
      //       }
      //       this.guests[i+this.selectContactTarget.index] = guests[i]
      //     }
      //   }
      //
      //   this.onGuestContactConfirm()
      // }
    },
    /** 设置乘客信息 */
    setGuestInfo(guestsShow, guest) {
      if(guest) {
        guestsShow.id = guest.id;
        guestsShow.birthplace = guestsShow.dateOfBirth = guestsShow.birthDate = guest.birthDate;
        guestsShow.callingCode = guest.callingCode;
        guestsShow.nationality = guest.nationality;
        guestsShow.chineseFirstName = guestsShow.firstName = guest.firstName;
        guestsShow.chineseLastName = guestsShow.lastName = guest.lastName;
        guestsShow.email = guestsShow.email = guest.email;
        guestsShow.gender = guestsShow.gender = guest.gender;
        guestsShow.isEdit = true;
        guestsShow.passPortExpirationDate = guestsShow.passportExpiresIn = guest.passportExpiresIn;
        guestsShow.passPortNum = guestsShow.passport = guest.passport;
        guestsShow.passengerName = guest.name;
        guestsShow.pinYinFirstName = guestsShow.pyFirstName = guest.pyFirstName;
        guestsShow.pinYinLastName = guestsShow.pyLastName = guest.pyLastName;
        guestsShow.telephone = guest.telephone;
      }
    },
    onClearGuest(guest) {
      if(guest && guest.id) {
        this.guestsShow[this.currentGuestIdx] = Object.assign({}, this.guests[this.currentGuestIdx]);
        this.tabsSwitch(this.currentGuestIdx);
        this.guestFillNum = this.guestsShow.filter(r=>r.isEdit === false).length;
        this.$forceUpdate();
      }
    },
    handleGuestsSwitch(obj, idx) {
      this.tabsSwitch(idx);
      this.$forceUpdate();
    },
    tabsSwitch(idx){
      this.guestsShow.forEach(r => { r.isSelected = false; });
      this.guestsShow[idx].isSelected = true;
      this.currentGuestIdx = idx;
    },
    /** 提交乘客信息 */
    submitFillGuests(){
      let guestNameComplete = '';
      let guestNameIncomplete = '';
      // this.bookingDetail.bookingRecordApi.bookingGuests.filter(r=> {
      //   if(!r.unFilledGuest) {
      //     guestNameComplete += r.passengerName + ',';
      //   }
      // });
      let verifyTelephoneCount = 0;
      this.guestsShow.forEach(r => {
        if(r.isEdit) {
          guestNameComplete += r.passengerName + ',';
        } else {
          guestNameIncomplete += r.passengerName + ',';
        }
        if(r.callingCode === "86") {
          if(r.telephone && r.telephone.length > 0 && !checkTel(r.telephone)) {
            verifyTelephoneCount++;
          }
        }
      });
      if(verifyTelephoneCount>0) {
        this.$alert.show('乘客手机号有误，请确认后再提交！');
        return;
      }

      let guestNameCompleteHtml = '';
      let guestNameIncompleteHtml = '';
      if(guestNameComplete) {
        guestNameCompleteHtml = `<div class="confirm-text">
                          <span>${guestNameComplete.substr(0,guestNameComplete.length-1)}</span>已完成填写，一旦提交将无法自助修改，请务必确认乘客信息正确，且同一航次无重复乘客后再提交。</div>`;
      }
      if(guestNameIncomplete) {
        guestNameIncompleteHtml = `<div class="confirm-text">
                          <span v-if="${guestNameIncomplete}">${guestNameIncomplete.substr(0,guestNameIncomplete.length-1)}</span>尚未完成必填信息，信息将不作保存。</div>`;
      }
      let confirmText = guestNameCompleteHtml + guestNameIncompleteHtml;
      this.$confirm.show(confirmText, {
        confirmCallBack: () => {
          if(guestNameComplete) {
            this.updateGuests();
          }
        },
      });
    },
    // 提交乘客信息(提交接口)
    async updateGuests () {
      let allGuests = [];
      let checkGuestsNum = this.guests.filter(r=>bookingHelper.checkGuestConfirm(r));
      if(!checkGuestsNum) return;

      this.guests.forEach(r=>{
        this.guestsShow.forEach(item=>{
          if(item.guestId === r.guestId) {
            if(r.unFilledGuest) {
              item.id && allGuests.push({
                //改为encId和encGuestId
                encId: item.encGuestId,
                firstName: item.firstName,
                lastName: item.lastName,
                birthDate: item.birthDate,
                gender: item.gender,
                pYFirstName: item.pyFirstName,
                pYLastName: item.pyLastName,
                telephone: item.telephone,
                Email: item.email,
                Passport: item.passPortNum,
                PassportExpiresIn: item.passPortExpirationDate
              });
            }
          }
        });
      });
      console.log(allGuests)
      if(allGuests.length > 0) {
        this.$loading.show();
        const { success, errMsg } = await api.booking.updateGuests({ 
          encBookingRecordId: this.bookingDetail.bookingRecordApi.encBookingRecordId, // 改为encBookingRecordId
          allGuests: allGuests
        });
        this.$loading.hide();
        if (!success) {
          console.error(errMsg);
          this.$alert.show(errMsg)
        } else {
          this.$alert.show('乘客信息提交成功，点击【确定】刷新页面。',{
            confirmCallBack: () => {
              // this.initPage();
              this.$router.go(0);
            }
          })
        }
      } else {
        this.initPage();
      }
    },
    // 乘客信息（录入方式）
    onGuestConfirm (guest, index) {
      this.guests[index] = guest
      this.setGuestInfo(this.guestsShow[this.currentGuestIdx], guest);
    },
    reload() {
      this.initPage();
      //location.reload();
    },
    getTikTokCouponStatus(status) {
      if (status === 1) {
        return "待审核"
      } else if (status === 3) {
        return "已拒绝"
      } else {
        return '';
      }
    },
    showQiaohuPopup() {
      this.isShowQiaohuPopup = true;
    },
    showStarrySkyPopup() {
      this.isShowStarrySkyPopup = true;
    },
    showCustomThemePopup(val) {
      this.personalizedStateroomInfo = val;
      this.isShowCustomThemePopup = true;
    },
    async getCruiseBanner() {
      const requestData = {
        businessType:2
      }
      const {success, data, errMsg} = await api.cruise.getCruiseBannerApi(requestData);
      if (success) {
        this.hsbcBanners = data
        console.log(this.hsbcBanners)
      } else {
        this.$alert.show(errMsg);
      }
    },
    onShowPopupsImg(idx){
      console.log('点击',idx)
      this.popupsImgUrl = ''
      this.popupsImgUrl = this.hsbcBanners[idx].popupImageUrl
      this.isShowPopupsImg = true
    },
    onClosePopups(){
      this.isShowPopupsImg = false
    },
    async showWxQrCode() {
      let params = {
        //改为encBookingRecordId
        encBookingRecordId:this.booking.encBookingRecordId
      }
      this.$loading.show()
      const {success, data, errMsg} = await api.booking.getWxQrCode(params)
      this.$loading.hide()
      if(success){
        this.wxQrCodeUrl = data
        this.isShowWxQrCodePopup = true
      }else{
        this.$alert.show(errMsg)
      }
    },
    closeWxQrCodePopup(){
      this.wxQrCodeUrl = ''
      this.isShowWxQrCodePopup = false
    },
    getBiddingStatusText(biddingStatus) {
      switch (biddingStatus) {
        case 0:
          return '竞价升房中';
        case 10:
          return '竞价成功';
        case 20:
          return '未竞价成功';
        case 30:
          return '竞价升房';
        case 40:
          return '竞价成功未付款';
        case 50:
          return '竞价成功已付款';
        default:
          return '';
      }
    },
    async goToPcp () {
      const { data } = await api.user.getPcpToken()
      let token = ""
      if (data && data.length > 0) {
        token = data
      }
      const url = `${process.env.VUE_APP_PCP_URL}/Rccl.Pcp/product/pcpShorex?token=${token}`
      location.href = url
    }
  },
  computed: {
    bookingKey () {
      return this.$store.state.booking.bookingKey
    },
    booking() {
      return this.bookingDetail.bookingRecordApi || {};
    },
    bookingGuests() {
      if (!this.booking) return [];

      this.booking.bookingGuests && this.booking.bookingGuests.forEach((guest)=> {
        this.booking.bookingGuestExts && this.booking.bookingGuestExts.forEach((guestExts)=> {
          if(guestExts.id === guest.id) {
            guest.enPassengerName = guestExts.enPassengerName;
            guest.passengerName = guestExts.passengerName;
            guest.unFilledGuest = guestExts.unFilledGuest;
          }
        })
      })
      return this.booking.bookingGuests || [];
    },
    agency() {
      return this.bookingDetail.agency;
    },
    bookingPrice() {
      return this.bookingDetail.bookingPrice;
    },
    guestsPrice() {
      if (!this.bookingPrice) return [];
      return this.bookingPrice.guestsPrice || [];
    },
    discountPriceItems() {
      if (
          !this.bookingPrice ||
          !this.bookingPrice.prices ||
          !this.bookingPrice.prices.priceInfo ||
          this.bookingPrice.prices.priceInfo.length == 0
      ) {
        return [];
      }
      const discountPrice = this.bookingPrice.prices.priceInfo.find(
          (r) => r.priceTypeCode == "DISCOUNT"
      );
      if (discountPrice && discountPrice.priceItems)
        return discountPrice.priceItems;
      return [];
    },
    discountedPrice() {
      if (!this.bookingPrice || !this.bookingPrice.priceInfo) return 0;
      // return this.bookingPrice.priceInfo.cabinPrice + this.bookingPrice.priceInfo.portPrice
      // + this.bookingPrice.priceInfo.optionPrice + this.bookingPrice.priceInfo.discountPrice
      return (
          this.bookingPrice.priceInfo.originalPrice +
          this.bookingPrice.priceInfo.discountPrice
      );
    },
    isShowPrice() {
      return (
          this.agency &&
          (this.agency.agencyType == 1 || this.agency.agencyType == 3)
      );
    },
    pcpOrder() {
      return this.bookingDetail.pcpOrderViewModel;
    },
    bookingPays() {
      return this.bookingDetail.bookingPays || [];
    },
    contact() {
      return this.targetContact;
    },
    contactName() {
      if (!this.contact || !this.contact.id) {
        return "";
      }
      if (
          this.contact.chineseLastName &&
          this.contact.chineseLastName.length > 0 &&
          this.contact.chineseFirstName &&
          this.contact.chineseFirstName.length > 0
      ) {
        return `${this.contact.chineseLastName}${this.contact.chineseFirstName}`;
      }
      return `${this.contact.pinYinLastName} ${this.contact.pinYinFirstName}`;
    },
    cruise() {
      if (!this.booking || !this.booking.cruisePartRecordView) {
        return {};
      }
      return this.booking.cruisePartRecordView;
    },
    retainTime() {
      if (!this.booking || !this.booking.createdDate) {
        return "";
      }
      const createDate = moment(this.booking.createdDate);
      if (this.bookingDetail.groupType == "QIAOHU") {
        return createDate.add(2, "hours").format("YYYY-MM-DD HH:mm:ss");
      } else if (
          this.bookingPays.length > 0 &&
          this.booking.finalPaymentTime != ""
      ) {
        return this.booking.finalPaymentTime;
      } else {
        return createDate.add(24, "hours").format("YYYY-MM-DD HH:mm:ss");
      }
    },
    currency() {
      if (this.bookingDetail.bookingCurrency) {
        return this.bookingDetail.bookingCurrency.currencyIcon;
      } else if (this.booking.currency == "CNY") {
        return "￥";
      } else if (this.booking.currency == "USD") {
        return "$";
      }
      return "";
    },
    payAmount() {
      if (this.bookingPays.length > 0) {
        return _.sumBy(this.bookingPays, 'amount')
      }
      return 0;
    },
    canPay() {
      return this.bookingDetail.canPay;
    },
    balanceDue() {
      return this.bookingDetail.balanceDue;
    },
    stateroom() {
      return this.bookingDetail.stateroomCategory || {};
    },
    stateroomName() {
      if (!this.stateroom) {
        return "";
      }
      let stateroomCNName = this.stateroom.stateroomCNName || "";
      if (
          this.bookingDetail.stateroomShelter &&
          this.bookingDetail.stateroomShelter.length > 0 &&
          stateroomCNName.indexOf("遮挡") < 0
      ) {
        stateroomCNName += "（有遮挡）";
      }
      return stateroomCNName;
    },
    stateroomCategoryCode() {
      if (!this.stateroom) {
        return "";
      }
      let code = this.stateroom.stateroomCategoryCode || "";
      if (code.indexOf("_") >= 0) {
        code = code.split("_")[0];
      }
      return code;
    },
    stateroomGuestNumber() {
      switch (this.bookingGuests.length) {
        case 1:
          return "单人房";
        case 2:
          return "双人房";
        case 3:
          return "三人房";
        case 4:
          return "四人房";
        default:
          return "";
      }
    },
    stateroomBalconyArea() {
      const stateroom = this.stateroom;
      if (
          !stateroom.stateroomBalconyArea ||
          stateroom.stateroomBalconyArea == "" ||
          stateroom.stateroomBalconyArea == "无"
      ) {
        return "无阳台";
      }
      if (stateroom.stateroomShelter && stateroom.stateroomShelter.length > 0) {
        return (
            "(" +
            stateroom.stateroomShelter +
            "视线遮挡) " +
            stateroom.stateroomBalconyArea
        );
      }
      return stateroom.stateroomBalconyArea;
    },
    nrp() {
      if (this.bookingDetail.isSevenDayNrpCruise) {
        return nrpConfig.sevenDayNrp;
      } else if (this.bookingDetail.isFortyEightHoursNrpCruise) {
        return nrpConfig.fortyEightHoursNrp;
      } else if (this.booking.isnrp) {
        return nrpConfig.nrp;
      } else {
        return nrpConfig.rp;
      }
    },
    nrpText() {
      return this.nrp.title;
    },
    isExpired() {
      if (
          !this.booking ||
          !this.booking.sailDate ||
          this.booking.sailDate == ""
      ) {
        return true;
      }
      const sailDate = moment(this.booking.sailDate);
      const today = moment();
      return today >= sailDate;
    },
    isNotPayInFull() {
      return (
          this.payAmount > 0 &&
          this.balanceDue > 0 &&
          this.payAmount < this.booking.amount
      );
    },
    canShorex() {
      const agency = this.bookingDetail.agency || {};
      return agency.canShorex && !agency.onlyOperateAdmin;
    },
    shorexes() {
      return this.bookingDetail.shorexs || [];
    },
    selectedShorex() {
      return this.bookingDetail.selectedShorex;
    },
    changeBookingContactLink() {
      return {
        name: "ChangeBookingContact",
        query: { bookingId: this.booking.encBookingId, returnUrl: location.href },// 使用加密字段encBookingId
      };
    },
    is2021Sailing() {
      let sailDate = this.booking.sailDate;
      if (!sailDate || sailDate.length < 10) return false;
      sailDate = sailDate.substring(0, 10);
      const time = new Date(sailDate);
      return time.getTime() >= new Date("2021-01-01").getTime();
    },
    shouldPayAmount() {
      return this.isSelectDeposit ? this.booking.downPay : this.balanceDue;
    },
    integral() {
      return numberWithCommas(this.bookingDetail.bookingIntegral.integral);
    },
    selectBookingGuestSpecials() {
      if (!this.booking) return [];
      const newBookingGuestSpecials = this.booking.bookingGuestSpecials || [];
      return newBookingGuestSpecials;
    },
    ruleDescription() {
      if (
          this.selectBookingGuestSpecials &&
          this.selectBookingGuestSpecials.length > 0
      ) {
        return (
            this.selectBookingGuestSpecials.find((r) => r)
                .specialBookingRuleDescription || ""
        );
      } else {
        return "";
      }
    },
    specialBookingType() {
      if (
          this.selectBookingGuestSpecials &&
          this.selectBookingGuestSpecials.length > 0
      ) {
        return (
            this.selectBookingGuestSpecials.find((r) => r).specialBookingType ||
            -1
        );
      } else {
        return -1;
      }
    },
    specialBookingImg() {
      if (
          this.selectBookingGuestSpecials &&
          this.selectBookingGuestSpecials.length > 0
      ) {
        return this.selectBookingGuestSpecials.find((r) => r).image || "";
      } else {
        return "";
      }
    },
    isBirthday() {
      return this.specialBookingType == SpecialBookingType.Birthday;
    },
    visaContent() {
      return this.bookingDetail.cruiseVisa || {};
    },
    selectContactPosition () {
      if (!this.selectContactTarget || !this.selectContactTarget.element) {
        return {}
      }
      const position = this.selectContactTarget.element.getBoundingClientRect()
      const parentPos = this.$refs.fillGuestForm.getBoundingClientRect()
      return {
        left: (position.left - parentPos.left) + 'px',
        top: (position.top - parentPos.top+100) + 'px'
      }
    },
    selectContactLimit () {
      if (!this.selectContactTarget || this.selectContactTarget.index < 0) return 1
      return this.booking.guestNumber - this.selectContactTarget.index
    },
    contacts () {
      return this.$store.state.user.contacts || []
    },
    isFinishSelfInfo(){
      let userInfo = this.$store.state.user.userInfo;
      let isLocalReward = userInfo && userInfo?.userIdentity && userInfo.userIdentity === 1
      return isLocalReward && userInfo.infoIntegrity === 100;
    },
    upgradeCabinItem(){
      if(this.bookingDetail.upgradeCabinItem){
        return this.bookingDetail.upgradeCabinItem
      }
      return  {}
    }
  },
  watch: {
    $route() {
      if (
          this.$router.currentRoute.query.bookingId &&
          this.booking.bookingId &&
          this.$router.currentRoute.query.bookingId != this.booking.bookingId
      ) {
        this.initPage();
      }
    }
  },
};
</script>

<style lang="less" scoped>
.fw-400 {
  font-weight: 400;
}

.fw-600 {
  font-weight: 600;
}

.blue {
  color: #54a3de;
}

.red {
  color: #ff3022;
}

.order_content {
  padding-bottom: 20px;
  background-color: #f0f0f0;

  .msg_con {
    text-align: center;
    line-height: 14px;
    padding: 13px 0;
    height: 36px;
  }

  .line_con {
    width: 100%;
    background-color: #fff;
    padding: 20px 20px 20px;
    overflow: hidden;
    border-top: 3px solid #e5f4ff;
    margin-bottom: 12px;
    position: relative;

    .line_info_con {
      float: left;
      max-width: 625px;
    }

    .ship_way {
      font-size: 22px;
      color: #282b2c;
      font-weight: 600;
    }

    .ship_time {
      font-size: 16px;
      color: #282b2c;
      padding: 5px 0px;
      line-height: 16px;
      font-weight: 400;

      span {
        margin-right: 20px;
      }

      .line_label {
        color: #747d80;
        margin-right: 5px;
      }

      .more_day {
        color: #006ab9;
        cursor: pointer;
        font-size: 14px;
        font-weight: 400;
        margin-left: 5px;
      }
    }

    .user_info {
      width: 530px;
      height: 127px;
      float: right;
      padding: 0 20px;
      position: relative;
      border-left: 1px solid #d3dadd;
    }

    .guestContact {
      span {
        margin-right: 0px;
      }
    }
  }

  .order_con {
    margin-bottom: 10px;

    .order_info_con {
      background-color: #e5f4ff;
      padding: 8px 20px;
      color: #757575;
      overflow: hidden;

      .info_text {
        color: #000000;
      }

      .or_stu {
        display: inline-block;
        padding: 6px 22px;
        border-radius: 12px;
        font-size: 12px;
        line-height: 12px;
        margin-left: 15px;
        text-align: center;
      }

      .or_stu_unpay {
        background-color: #fbc500;
        color: #282b2c;
      }

      .or_stu_paid {
        background-color: #006ab9;
        color: #fff;
      }

      .reject_text {
        display: inline-block;
        line-height: 24px;
        color: #7f8081;
      }
    }

    .c_infoImg,
    .connect_room_link,
    .qiaohu_tag {
      cursor: pointer;
      margin-left: 5px;
    }
    .PCPGIFT_THEME_CSS {
      height: 33px;
    }
    .CUSTOM_THEME_CSS {
      height: 30px;
    }

    .room_con {
      background-color: #fff;
      padding: 20px 20px 10px;

      .head_con {
        font-size: 22px;
        color: #282b2c;
        position: relative;
        display: flex;
        align-items: center;

        .head_tag {
          display: block;
          padding: 0 16px;
          background-color: #e5f4ff;
          border-radius: 12px;
          font-size: 12px;
          line-height: 24px;
          height: 24px;
          color: #006ab9;
          text-align: center;
          cursor: pointer;
        }

        .nrpTooltip {
          font-size: 12px;
          line-height: 18px;
          cursor: pointer;
          color: #006ab9;
          font-weight: 400;
          margin-left: 5px;
          position: relative;
          //top: 2px;
        }
        .bidding-status{
          position: absolute;
          right: 0;
          top: 2px;
          padding: 0 12px;
          //width: 120px;
          height: 33px;
          text-align: center;
          line-height: 33px;
          font-size: 16px;
          background: #036ab9;
          color: #fff;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 5px;
          border-radius: 16px;
          cursor: pointer;
          img{
            display: block;
            width: 16px;
            height: 16px;
          }
        }
      }

      .room_det {
        font-size: 14px;
        color: #747d80;
        margin-top: 8px;
        line-height: 14px;
        margin-bottom: 14px;
        padding: 5px 10px;
        background-color: #f3f6f8;
      }

      .usr_con {
        overflow: hidden;
        margin-bottom: 10px;

        .usr_head_con {
          overflow: hidden;
          background-color: #f3f6f8;
          border: solid 1px #d3dadd;
          height: 40px;

          .usr_head {
            float: left;
            padding-left: 20px;
            line-height: 40px;
            font-size: 20px;
          }

          .head_rg {
            float: right;
            width: 378px;
            font-size: 20px;
            line-height: 40px;
          }

          .text {
            display: inline-block;
            font-size: 14px;
            line-height: 18px;
            color: #006ab9;
            cursor: pointer;
            position: relative;
            top: 9px;
            left: 5px;

            .icon {
              height: 18px;
              line-height: 18px;
              margin-top: -2px;
              margin-left: 16px;
              cursor: pointer;
            }

            span {
              margin-left: 5px;
            }
          }
        }

        .info_con {
          border: solid 1px #d3dadd;
          border-top: none;
          overflow: hidden;
          padding: 20px 22px;

          .info_lf {
            float: left;

            .det_lf {
              float: left;
              width: 206px;
              font-size: 14px;
              line-height: 24px;
              color: #757575;

              .text {
                color: #282b2c;
              }
            }

            .det_rg {
              width: auto;
            }
          }

          .info_rg {
            float: right;

            .price_con {
              width: 378px;
              padding-left: 20px;
              border-left: 1px solid #d3dadd;

              div {
                width: 100%;
                margin-bottom: 10px;

                .text {
                  float: right;
                }
              }
            }
          }
        }
      }

      .pr_con {
        overflow: hidden;

        .price_box {
          width: 378px;
          float: right;
          color: #282b2c;

          div {
            margin: 10px 0;

            .text {
              float: right;
              display: inline-block;
              padding-right: 20px;
            }
          }

          .pr_count_con {
            background-color: #f3f6f8;
            padding: 1px 0;
            padding-left: 8px;
          }

          .line {
            width: 100%;
            height: 1px;
            background-color: #d3dadd;
            margin: 0;
          }
        }
      }

      .specialBookinginfo_con {
        overflow: hidden;
        margin-bottom: 10px;

        .specialBookinginfo_head_con {
          overflow: hidden;
          background-color: #fbc500;
          border: solid 1px #d3dadd;
          height: 5px;
        }

        .info_con {
          border: solid 1px #d3dadd;
          border-top: none;
          overflow: hidden;
          padding: 20px 22px;
          width: 100%;
          display: flex;
          justify-content: space-between;
          .specialDet_lf {
            font-size: 14px;
            line-height: 24px;
            color: #757575;

            .text {
              color: #282b2c;
              text-decoration: underline;
            }

            .specialBookinginfo_title_con {
              width: 25px;
              //height: 25px;
              margin-right: 12px;
            }

            .specialBookinginfo_ruleDescription_con {
              margin-left: 9px;
            }

            .specialBookinginfo_text {
              color: #282b2c;
            }

            .specialBookinginfo_info {
              padding-left: 37px;
              padding-top: 10px;

              div {
                span {
                  margin-right: 9px;
                }
              }
            }

            .specialBookinginfo_title_click {
              cursor: pointer;
            }
          }
          .birthday-right{
            width: 378px;
            padding-left: 20px;
            border-left: 1px solid #d3dadd;
            display: flex;
            justify-content: space-between;
          }
        }
      }
    }
  }

  .choose_pay_con {
    .pay_title {
      font-size: 22px;
      font-weight: 400;
      color: #282b2c;
    }

    .pay_way_con {
      overflow: hidden;
      margin-top: 15px;

      .pay_way_item {
        float: left;
        margin-right: 10px;
        width: 232px;
        height: 60px;
        line-height: 60px;
        text-align: center;
        background-color: #ffffff;
        border: solid 1px #d3dadd;
        color: #006ab9;
        cursor: pointer;
        position: relative;

        .offline-pay-tips {
          font-size: 12px;
          color: red;
          position: absolute;
          top: 41px;
          left: 95px;
          line-height: 12px;
        }
      }

      .pay_way_item.active {
        border: solid 2px #fbc500;
      }
    }

    .pay_text {
      line-height: 20px;
      margin: 5px 0;
      color: #747d80;
    }
  }
  .deposit-con{
    height: 44px;
    background: #FFF2D2;
    display: flex;
    justify-content: flex-end;
    padding-right: 34px;
    gap: 51px;
    .deposit-text{
      display: flex;
      align-items: center;
      font-weight: 500;
      font-size: 16px;
      color: #666666;
      .deposit-icon{
        width: 16px;
        height: 16px;
        margin-right: 3px;
      }
      .downpay_icon{
        width: 15px;
        height: 15px;
        margin-left: 9px;
        cursor: pointer;
      }
    }
    .deposit-select{
      display: flex;
      align-items: center;
      font-weight: 500;
      font-size: 16px;
      color: #666666;
      gap: 4px;
    }
  }


  .order_ft_con {
    //overflow: hidden;
    height: 52px;
    background-color: #fff;

    .ft_lf {
      float: left;
      border-top: 1px solid #d3dadd;
      width: calc(100% - 216px);
      padding: 4px 10px;
      text-align: right;

      .unpaid_rg {
        float: right;
      }

      .total-text {
        display: inline-block;
        vertical-align: bottom;
        position: relative;
        top: -5px;
      }

      .text {
        font-size: 30px;
        color: #ff3022;
        font-weight: 400;
        display: inline-block;
        vertical-align: bottom;

        .text-currency {
          font-size: 16px;
        }

        #netAmountText {
          font-weight: 600;
        }
      }

      .unpaid_lf {
        float: right;
        margin-right: 10px;
        border-right: solid 1px #d3dadd;
        margin-top: 15px;
        padding: 0px 10px 0px;

        .unpaid_lf_text {
          display: inline-block;
          vertical-align: middle;
          margin-left: 10px;
        }

        .downpay_icon {
          vertical-align: -2px;
          cursor: pointer;
          margin: 0px 4px;
        }
      }

      .un_jifen {
        float: left;
        font-size: 14px;
        color: rgb(40, 43, 44);
        font-weight: 400;
        margin-left: 9px;
        // line-height: 44px;
        font-weight: 600;
        text-align: left;

        span {
          color: #3388c8;
        }

        img {
          vertical-align: -2px;
          cursor: pointer;
        }
      }
    }

    .ft_rg {
      float: left;
      font-size: 18px;
      color: #282b2c;
      height: 52px;
      background-color: #fbc500;
      line-height: 52px;
      padding: 0 72px;
      cursor: pointer;
    }
  }

  .order_ico_25 {
    width: 16px;
    height: 16px;
    display: inline-block;
    vertical-align: middle;
    background: url(https://resource.rcclchina.com.cn/tui2/order/icon-edit.png)
    no-repeat;
  }

  .order_ico_25.edit_ico {
    background-position: 0px 0px;
  }

  .shore_excursion {
    width: 100%;
    background-color: #fff;
    padding: 20px 20px 20px;
    overflow: hidden;
    border-top: 3px solid #e5f4ff;
    margin-bottom: 12px;

    .shore_title {
      font-size: 22px;
      font-weight: 400;
      color: #282b2c;
    }

    .shore_notice {
      position: relative;

      .total {
        position: absolute;
        right: 23px;
        top: 10px;
      }
    }

    .parah-num {
      display: inline-block;
      width: 20px;
    }

    .shore_notice.has_shorex_notice {
      border-top: solid 1px #d9dfe1;
      padding-top: 14px;

      .notice_1 {
        text-align: left;
        margin-top: 3px;
      }
    }

    .modify_sight.not_selected_shorex {
      width: 148px;
      margin-top: 12px;
    }

    .notice_1 {
      margin-top: 25px;
      text-align: center;
    }

    .shore_subtitle {
      font-size: 22px;
      font-weight: normal;
      color: #565858;
      margin: 28px 0 16px 0;
    }

    li {
      overflow: hidden;
      margin-bottom: 30px;
    }

    .shore_intro {
      margin-left: 18px;

      .shore_sight {
        font-weight: bold;
        color: #282b2c;
        font-size: 16px;
      }
    }

    .shore_intro.shorex_free {
      margin-left: 0px;

      .shore_sight {
        border-left: solid 3px #5fade2;
        padding-left: 6px;
      }
    }

    .modify_sight {
      width: 220px;
      height: 40px;
      margin: 20px auto;
      background: #fbc500;
      color: #282b2c;
      font-size: 14px;
      line-height: 40px;
      text-align: center;
      cursor: pointer;
    }

    .modify_sight.has_shorex_notice {
      height: 50px;
      line-height: 50px;
    }

    .shore_img {
      width: 220px;
    }
  }
}

.booking-fill-guests {
  padding: 20px;
  border: 1px solid #D8DFE2;
  border-left: 3px solid #fbc500;
  & .fill-guest-tabs-main {
    display: flex;
    align-items: center;
    border-radius: 2px;
    & .fill-guests-tabs {
      margin: 0;
      padding: 0;
      & > li {
        display: inline-block;
        margin-right: 20px;
        width: 80px;
        height: 36px;
        line-height: 36px;
        text-align: center;
        border-radius: 3px;
        cursor: pointer;
        border: 1px solid #FBC500;
        color: #333333;
        &.is-selected {
          background-color: #FBC500;
        }
      }
    }
    & .fill-guests-prompt {
      color: #999999;
    }
  }
}
& .booking-fill-guests-btn {
  display: block;
  width: 190px;
  height: 36px;
  line-height: 36px;
  text-align: center;
  border-radius: 3px;
  font-weight: bold;
  margin: 10px auto 30px;
  background-color: #FBC500;
  color: #333333;
}
.privacy-layout {
  position: absolute;
  top: 5px;
  left: 140px;
}
</style>

<style lang="less">
.shore_excursion .shore_intro .shore_t {
  margin: 10px 0 8px 0;
  font-size: 16px;
  font-weight: 400;
}

.shore_excursion .shore_intro.shorex_free .shore_t,
.shore_excursion .shore_intro.shorex_free .shore_t p,
.shore_excursion .shore_intro.shorex_free .shore_t span {
  font-size: 14px !important;
  font-weight: bold !important;
}

.shore_excursion .shore_intro.shorex_free .shore_t {
  margin-top: 15px;
}

.order_content {
  .nrp-tag.stateroomDetailNrp {
    text-decoration: none;
  }
  .nrp-tag {
    .fortyEightHoursNrpSwitchTips {
      display: none;
    }
  }
}

.fortyEightTag_bookingDetail_tag {
  .fortyEightHoursNrpSwitchTips {
    display: none;
  }
}
.confirm-text {
  color: #777777;
  & span {
    font-weight: 600;
    margin-right: 5px;
    color: #001654;
  }
}
.hsbcBanner{
  width: 100%;
  height: 130px;
  margin: 10px 0;
  &  .swiper-container {
    width: 100%;
    height: 130px;
    border-radius: 5px;
    overflow: hidden;
  }
  & .swiper-slide{
    width: 100%;
    height: 130px;
  }
  & img{
    width: 100%;
    height: 100%;
  }
}
.integral_lf {
  float: left;
  font-size: 16px;
  font-weight: bold;
  color: #282b2c;
  text-align: left;
  height: 40px;
  display: flex;
  align-items: center;
  & > span {
    padding: 0 5px;
    color: #348cc8;
  }
}
.selectShorex-css{
  margin-top: 10px;
  cursor: pointer;
  span{
    color: #016bba;
  }
}
</style>
